import baguetteBox from 'baguettebox.js';
import Glide from '@glidejs/glide';

export default function PhotoGalleryCarousel() {

    let photoGalleryCarouselWrapper = document.querySelector('.photo-gallery-carousel_wrapper');

    if(photoGalleryCarouselWrapper) {
        const carousel = new Glide('.glide', {
            type: 'carousel',
            autoplay: 5000,
            animationDuration: 800,
            startAt: 0,
            gap: 30,
            perView: 3,
            breakpoints: {
                991: { perView: 1 }
            }
        })
        carousel.mount();

        baguetteBox && baguetteBox.run('.photo-gallery-carousel_wrapper', {
            buttons: true,
            ignoreClass: 'glide__slide--clone'
        });
    }
}